import React from 'react'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { TourismEmbedConfiguratorContainer } from './TourismEmbedConfigurator'
import { Provider } from 'react-redux'
import { initStore } from './redux/initStore'
import queryString from 'query-string'

const store = initStore()

export class TourismEmbedConfiguratorApp extends React.PureComponent {
  render () {
    const params = queryString.parse(this.props.location.search)
    return (
      <Provider store={store}>
        <StandardLayout>
          <TourismEmbedConfiguratorContainer {...params} />
        </StandardLayout>
      </Provider>
    )
  }
}
